import React from 'react';

const Footer = () => {
  const date = new Date();

  return (
    <footer style={{ backgroundColor: "#1D4857", color: "#ffffff", padding: "1rem 0" }}>
      <div className="container-fluid">
        <div className="container">
          <div className="row">
            <div className="col text-start">
              <span>
                &copy; {date.getFullYear()} Baskar Ganapathysubramanian
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
